import { apiFetch } from './api'

export async function generateTeamLogo({ name, description, mcaptchaToken }) {
  const payload = { name, description }
  if (mcaptchaToken) payload.mcaptchaToken = mcaptchaToken
  return apiFetch('/Ai/generate-logo', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function polishText({ scope, text }) {
  return apiFetch('/Ai/polish-text', {
    method: 'POST',
    body: JSON.stringify({ scope, text }),
  })
}

export async function executeCommand({ command }) {
  return apiFetch('/Ai/command', {
    method: 'POST',
    body: JSON.stringify({ command }),
  })
}

export async function getSelfHostedChatPrompt() {
  return apiFetch('/Ai/self-hosted-chat-prompt')
}

export async function designBracket({ teamCount, requirements }) {
  return apiFetch('/Ai/design-bracket', {
    method: 'POST',
    body: JSON.stringify({ teamCount, requirements }),
  })
}

export async function parseGameRecordImage(dto) {
  return apiFetch('/Ai/parse-game-record-image', {
    method: 'POST',
    body: JSON.stringify(dto),
  })
}

export default { generateTeamLogo, polishText, executeCommand, getSelfHostedChatPrompt, designBracket, parseGameRecordImage }

